import { observer } from "mobx-react";
import { __ } from "../../utils";
import { List, Checkbox } from "antd";
import { PluginUpdateLicenseListItem } from ".";
const PluginUpdateLicenseList = observer(({
  onDeactivate,
  pluginUpdate
}) => {
  const {
    licensedEntries
  } = pluginUpdate;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(List, {
    itemLayout: "vertical",
    size: "small",
    dataSource: licensedEntries,
    renderItem: license => /*#__PURE__*/React.createElement(PluginUpdateLicenseListItem, {
      license: license,
      onDeactivate: onDeactivate
    })
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    disabled: pluginUpdate.busy,
    checked: pluginUpdate.announcementsActive,
    onChange: e => pluginUpdate.setAnnouncementActive(e.target.checked)
  }, __("Show announcements for this plugin"))));
});
export { PluginUpdateLicenseList };